import { render, staticRenderFns } from "./step-custom-priceV3.vue?vue&type=template&id=277e0ce6&scoped=true&"
import script from "./step-custom-priceV3.vue?vue&type=script&lang=js&"
export * from "./step-custom-priceV3.vue?vue&type=script&lang=js&"
import style0 from "./step-custom-priceV3.vue?vue&type=style&index=0&id=277e0ce6&lang=scss&scoped=true&"
import style1 from "./step-custom-priceV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e0ce6",
  null
  
)

export default component.exports